import {
    Input,
    HostBinding
} from '@angular/core';
import { Common } from './common';

/**
 * Base class for all components which hold common properties
 * This includes state settings such as visibility and enabling
 */
export abstract class Appearance extends Common {
    // io
    /**
     * Specifies whether the component is visible
     */
    get visible(): boolean {
        return !this._hidden;
    }
    @Input() set visible(value: boolean) {
        this._hidden = !value;
    }
    // host bindings
    /**
     * Specifies whether the component responds to user interaction
     */
    @Input() @HostBinding('class.state-disabled') disabled: boolean = false;
    @HostBinding('class.state-invisible') private _hidden: boolean = false;
}



// WEBPACK FOOTER //
// ./client-src/app/core/baseObjects/appearance.ts